module.exports = function smoothScroll() {
	const links = document.querySelectorAll(
		'a[href*="#"]:not([href="#"]):not([href="#0"])',
	);

	links.forEach((link) => {
		link.addEventListener('click', function (event) {
			const pathnameMatch =
				location.pathname.replace(/^\//, '') ===
				this.pathname.replace(/^\//, '');

			const hostnameMatch = location.hostname === this.hostname;

			if (!pathnameMatch || !hostnameMatch) return;

			const hash = this.hash;
			let target = document.querySelector(hash);

			if (!target) {
				target = document.querySelector(`[name="${hash.slice(1)}"]`);
			}

			if (!target) return;

			event.preventDefault();

			// 👉 Offset dynamique basé sur le header
			const header = document.querySelector('.site-header');
			const getOffset = () => {
				const header = document.querySelector('.site-header');
				return header ? header.offsetHeight : 100;
			};
			const offset = getOffset();

			const targetPosition =
				target.getBoundingClientRect().top + window.pageYOffset - offset;

			window.scrollTo({
				top: targetPosition,
				behavior: 'smooth',
			});

			// Gestion du focus après animation
			setTimeout(() => {
				target.focus();

				if (document.activeElement !== target) {
					target.setAttribute('tabindex', '-1');
					target.focus();
				}
			}, 800);
		});
	});
};
